<template>
<div class="chapter">
<div class="inner_page">
<a id="p1"></a>
<h1 class="fronttitle smallcaps">Guest Editors of the Best American Essays</h1>
<p class="left ">1986 <span class="smallcaps">ELIZABETH HARDWICK</span></p>
<p class="left ">1987 <span class="smallcaps">GAY TALESE</span></p>
<p class="left ">1988 <span class="smallcaps">ANNIE DILLARD</span></p>
<p class="left ">1989 <span class="smallcaps">GEOFFREY WOLFF</span></p>
<p class="left ">1990 <span class="smallcaps">JUSTIN KAPLAN</span></p>
<p class="left ">1991 <span class="smallcaps">JOYCE CAROL OATES</span></p>
<p class="left ">1992 <span class="smallcaps">SUSAN SONTAG</span></p>
<p class="left ">1993 <span class="smallcaps">JOSEPH EPSTEIN</span></p>
<p class="left ">1994 <span class="smallcaps">TRACY KIDDER</span></p>
<p class="left ">1995 <span class="smallcaps">JAMAICA KINCAID</span></p>
<p class="left ">1996 <span class="smallcaps">GEOFFREY C. WARD</span></p>
<p class="left ">1997 <span class="smallcaps">IAN FRAZIER</span></p>
<p class="left ">1998 <span class="smallcaps">CYNTHIA OZICK</span></p>
<p class="left ">1999 <span class="smallcaps">EDWARD HOAGLAND</span></p>
<p class="left ">2000 <span class="smallcaps">ALAN LIGHTMAN</span></p>
<p class="left ">2001 <span class="smallcaps">KATHLEEN NORRIS</span></p>
<p class="left ">2002 <span class="smallcaps">STEPHEN JAY GOULD</span></p>
<p class="left ">2003 <span class="smallcaps">ANNE FADIMAN</span></p>
<p class="left ">2004 <span class="smallcaps">LOUIS MENAND</span></p>
<p class="left ">2005 <span class="smallcaps">SUSAN ORLEAN</span></p>
<p class="left ">2006 <span class="smallcaps">LAUREN SLATER</span></p>
<p class="left ">2007 <span class="smallcaps">DAVID FOSTER WALLACE</span></p>
<p class="left ">2008 <span class="smallcaps">ADAM GOPNIK</span></p>
<p class="left ">2009 <span class="smallcaps">MARY OLIVER</span></p>
<p class="left ">2010 <span class="smallcaps">CHRISTOPHER HITCHENS</span></p>
<p class="left ">2011 <span class="smallcaps">EDWIDGE DANTICAT</span></p>
<p class="left ">2012 <span class="smallcaps">DAVID BROOKS</span></p>
<p class="left ">2013 <span class="smallcaps">CHERYL STRAYED</span></p>
<p class="left ">2014 <span class="smallcaps">JOHN JEREMIAH SULLIVAN</span></p>
<p class="left ">2015 <span class="smallcaps">ARIEL LEVY</span></p>
<p class="left ">2016 <span class="smallcaps">JONATHAN FRANZEN</span></p>
<p class="left ">2017 <span class="smallcaps">LESLIE JAMISON</span></p>
<p class="left ">2018 <span class="smallcaps">HILTON ALS</span></p>
<p class="left ">2019 <span class="smallcaps">REBECCA SOLNIT</span></p>
<p class="left ">2020 <span class="smallcaps">ANDRé ACIMAN</span></p>
<p class="left ">2021 <span class="smallcaps">KATHRYN SCHULZ</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front01.vue?1bc8cb7e